import React from 'react';
import BoxPlaceholder from "../BoxPlaceholder/BoxPlaceholder";

const ButtonPlaceholder = () => {
  return (
    <BoxPlaceholder className={"h-10 w-32"}/>
  );
};

export default ButtonPlaceholder;